<template>
  <div>
    <Row>
      <Form ref="querySysDictTypeForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Form-item :label="this.$t('common.sys-dict-typ.sign.label')" prop="sign">
            <Input v-model="query.sign" :placeholder="$t('common.sys-dict-typ.sign.holder')" style="width: 200px" />
        </Form-item>
        <Form-item :label="this.$t('common.sys-dict-typ.label.label')" prop="label">
            <Input v-model="query.label" :placeholder="$t('common.sys-dict-typ.label.holder')" style="width: 200px" />
        </Form-item>
        <Form-item :label="this.$t('common.sys-dict-typ.status.label')" prop="status">
        <Select v-model="query.status" clearable filterable :placeholder="$t('common.sys-dict-typ.status.holder')">
          <Option v-for="item in $t('common.sys-dict-typ.status.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        </Form-item>
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openSysDictTypeDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="sysDictTypeTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
<!--        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.sysDictTypeTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>-->
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="sysDictTypeDrawer" :title="this.$t('drawer.title')[sysDictTypeDrawer.type]" :visible.sync="sysDictTypeDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <sysDictType-form ref="sysDictTypeForm"/>
        <div class="right-drawer__footer" v-if="sysDictTypeDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="sysDictTypeDrawer.submiting">{{ sysDictTypeDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="sysDictTypeDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import SysDictTypeForm from '@/views/common/sys-dict-type/components/Form.vue';
Vue.component('sysDictType-form', SysDictTypeForm);

export default {
  name: 'aip-common-sysDictType-index',
  mixins:[mixin],
  data () {
    return {
      query:{
          name:''
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      sysDictTypeDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  methods: {
    handleSearch(){
      this.page.loading = true;
      api.common.SysDictType.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openSysDictTypeDrawer(sysDictType){
      this.sysDictTypeDrawer.visible = true
      this.sysDictTypeDrawer.type = sysDictType ? sysDictType.type : 'add'
      this.$nextTick(()=>{
          if(sysDictType){
              this.$refs['sysDictTypeForm'].getSysDictType(sysDictType.id,sysDictType.type)
          }else{
            this.$refs['sysDictTypeForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.sysDictTypeDrawer.submiting = true;
        this.$refs.sysDictTypeForm.handleSubmit(
          data=>{
            this.sysDictTypeDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.sysDictTypeDrawer.visible=false, 1000);
          },
          ()=>{
            this.sysDictTypeDrawer.submiting = false;
          }
        )
    },
    deleteSysDictType(id){
      api.common.SysDictType.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.common.SysDictType.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          /*{key: 'id', width: 60, fixed:'left',type:'selection'},*/

          {key: 'sign', align:'center',minWidth: 200,fixed:'left', title:  this.$t('common.sys-dict-typ.sign.label')},
          {key: 'label', align:'center',minWidth: 200, title:  this.$t('common.sys-dict-typ.label.label')},
          {
            key: 'status',
            align: 'center',
            width: 120,

            column:'status',
            filters: this.$t('common.sys-dict-typ.status.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.status = value
              this.handleSearch();
            },
            title: this.$t('common.sys-dict-typ.status.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.status==t.value).label}</div>
            }
          },
          {key: 'remark', align:'center',minWidth: 300, title:  this.$t('common.sys-dict-typ.remark.label')},
          {key: 'createTime', align: 'center', width:200, title: this.$t('common.sys-dict-typ.createTime.label'),},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 180,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openSysDictTypeDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openSysDictTypeDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true} onOn-ok={()=>this.deleteSysDictType(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
